import React, { Fragment } from 'react';
import './App.scss';
import Rotas from './routes';

const App = () => (
  <Fragment>
    <Rotas/>
  </Fragment>
)

export default App;
